export const IMAGE_TYPE_ACCEPT = ["image/jpeg", "image/pjpeg", "image/png"];

export const DOMAIN = process.env.REACT_APP_API_BASE_URL?.replace("/api", "");
